import { render, staticRenderFns } from "./MidiaTextoHorizontalView.vue?vue&type=template&id=6d9403b1&scoped=true"
import script from "./MidiaTextoHorizontalView.vue?vue&type=script&lang=js"
export * from "./MidiaTextoHorizontalView.vue?vue&type=script&lang=js"
import style0 from "./MidiaTextoHorizontalView.vue?vue&type=style&index=0&id=6d9403b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9403b1",
  null
  
)

export default component.exports